/* Hook encargado de eliminar una imagen del vehiculo

Autor: Benjamín León
Fecha: 2024-12-01
*/
import { useState } from 'react'

import { customDelete } from '../utils/customFetch'

import { makeUrlPictureDelete } from './connectionData'

interface ApiParams {
  id: string
  vehicle: string
  registry: boolean
  attachmentId: string
}

const usePictureDelete = () => {
  const [errorPicture, setErrorPicture] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const pictureDelete = async (id: string, vehicle: string, registry: boolean, attachmentId: string) => {
    setLoading(true)

    try {
      const apiParams: ApiParams = { id: id, vehicle: vehicle, registry: registry, attachmentId: attachmentId }
      const apiUrl = makeUrlPictureDelete()
      await customDelete(apiUrl, apiParams)
      setErrorPicture(null)

      return
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPicture(err)
      } else {
        setErrorPicture(new Error('An unknown error occurred'))
      }

      return
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorPicture, loading, pictureDelete }
}
export default usePictureDelete
